<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    closeless
    canceless
    successless
    @closed="$emit('closed')"
  >
    <div style="text-align: center;">
      <v-progress-circular style="margin: 16px;" :size="32" color="primary" indeterminate />

      <div>
        Файл загружается. Не закрывайте и не покидайте страницу, пока загрузка
        не завершится. После завершения загрузки файла на сервер вы будете
        автоматически перенаправлены на страницу со списком процедур.
      </div>
    </div>
  </BModalConfirm>
</template>

<script>
import { toString } from 'lodash'
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import { MarksFilesApi } from '@/api/resources/Marks'

export default {
  components: {
    BModalConfirm,
  },
  titleText: 'Загрузка файла',
  props: {
    procedureId: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    async process(file) {
      const { which } = this.$route.query
      const fApi = new MarksFilesApi()

      try {
        const {
          data: { file_id },
        } = await fApi.upload({
          procedure_id: toString(this.procedureId),
          file_type: `${which}_FILE`,
          file,
        })
        this.$emit('success', file_id)
        this.close()
      } catch (e) {
        this.$notice.errors(e)
        this.close()
      }
    },
    open(file) {
      this.$refs.modal.open()
      this.process(file)
    },
    close(...args) {
      return this.$refs.modal.close(...args)
    },
  },
}
</script>
